/** Key used by RVE SDK to persist browser (CSR) vs cloud render mode. */
const RVE_WEB_RENDER_STORAGE_KEY = 'rve:webRender';

/**
 * Force preview composition mode so timeline stickers render on the canvas.
 *
 * The SDK's `LayerContent` returns `null` for sticker items when `webRender` is true
 * (browser/CSR rasterizer). Hydration from `localStorage` can flip `webRender` on even
 * when `enableWebRender={false}` — e.g. stored `"false"` with no cloud renderer resolves
 * to `true` in the SDK. Persist `"false"` so preview composition mode stays off.
 */
export function resetNeoPreviewRenderMode(): void {
  try {
    localStorage.setItem(RVE_WEB_RENDER_STORAGE_KEY, 'false');
  } catch {
    // Private mode / blocked storage — preview may still work if webRender stays false.
  }
}
